import React from 'react';
import { motion } from 'framer-motion';

const modes = [
  { label: 'Recommended', title: 'Staff-first, AI-fallback', desc: 'Your team answers first. After 15–25 seconds unanswered, the call forwards to Valtivo AI. Best for most operators.' },
  { label: 'Optional', title: 'After-hours only', desc: 'Calls outside business hours route directly to Valtivo. Your team handles all in-hours calls normally.' },
  { label: 'Optional', title: 'Overflow only', desc: 'Calls that hit a busy signal or go unanswered during peak volume route to Valtivo.' },
];

const DeploymentModel = () => (
  <section className="py-20 border-t" style={{ background: '#0d0d0d', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>Integration</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#f1f1f1' }}>No phone-number change required.</h2>
        <p className="text-base max-w-2xl leading-relaxed" style={{ color: '#888' }}>
          You keep your current number and phone system. Your office manager, admin, or phone vendor adds a simple conditional forwarding rule. We handle the AI side: scripts, logic, integrations, testing, and optimization.
        </p>
      </motion.div>
      <div className="grid md:grid-cols-3 gap-6">
        {modes.map((m, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="p-6 rounded-2xl border" style={{ background: '#111', borderColor: i === 0 ? '#2d6a4f' : '#1f1f1f' }}>
            <span className="inline-block text-xs font-bold px-2 py-1 rounded mb-4"
              style={{ background: i === 0 ? '#1a3a2a' : '#1a1a1a', color: i === 0 ? '#4ade80' : '#666' }}>
              {m.label}
            </span>
            <h3 className="text-base font-semibold mb-2" style={{ color: '#f1f1f1' }}>{m.title}</h3>
            <p className="text-sm leading-relaxed" style={{ color: '#666' }}>{m.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default DeploymentModel;